import { ElementType } from "react";

import { Box, SvgIcon } from "@mui/material";
import { FormControlLabel, Typography } from "components";
import { gray } from "configs/colors";

interface Props {
  label: string;
  gap?: number | string;
  icon?: ElementType;
  content?: React.ReactNode;
  contentHeight?: string | number;
}

const IndexComponent: React.FC<Props> = ({
  label,
  gap = 1.5,
  icon,
  content,
  contentHeight,
}) => (
  <FormControlLabel
    label={label}
    control={
      <Box
        display="flex"
        alignItems="center"
        gap={gap}
        height={contentHeight}
        color={gray[700]}
      >
        {icon ? (
          <SvgIcon
            fontSize="small"
            component={icon as unknown as ElementType}
            sx={{ fill: "none", flex: "0 0 auto" }}
          />
        ) : null}
        <Typography type="TextMD" fontWeight={500}>
          {content}
        </Typography>
      </Box>
    }
  />
);

export default IndexComponent;
